(function () {
  /**
   * @deprecated Please use src2/core/models/user/UserRolesConstants.js
   */
  angular
    .module('binky.core.user.roles')
    // eslint-disable-next-line angular/window-service
    .constant('USER_ROLE', window.binkySrc2.models.user.USER_ROLES_CONSTANTS);
})();
